/**
 * WordPress dependencies
 */
export { isBlobURL } from '@wordpress/blob';
